import { combineReducers } from 'redux'
// reducer imports go here

export default combineReducers({
    // reducers go here
})